<span
  data-test="JdCNDrtq"
  class="status-dot"
  [class]="colorClass"
  [mdTooltip]="tooltipText"
></span>
